import React from 'react';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, InputLabel, MenuItem, Select, FormControl } from '@mui/material';
//
import { BaseOptionChart } from '../../../../components/chart';
import { useQuery, useParameterizedQuery } from 'react-fetching-library';
import { getGlobalStatisticsDataAction, getSeasonsAction } from '../../../../services/request';

export const InfluenceChart = props => {
  const { data } = props;

  const { loading, payload, error } = useQuery(getSeasonsAction(null, 'GET'));
  const [seasons, setSeasons] = React.useState();
  const [season, setSeason] = React.useState('');
  const compareQuery = useParameterizedQuery(getGlobalStatisticsDataAction);
  const [compareData, setCompareData] = React.useState(null);

  React.useEffect(() => {
    if (!loading && !error) {
      setSeasons(payload.results);
    }
  }, [loading]);

  const handleCompareSeasonChange = event => {
    const id = event.target.value;
    setSeason(id);
    getCompareData(id);
  };


  const getCompareData = async id => {
    const { payload, error, loading } = await compareQuery.query(id);
    if (!error && !loading) {
      setCompareData(payload.influence_data);
    }
  };

  const CHART_DATA = [
    {
      type: 'column',
      name: 'Aktualne wpływy',
      data: _.map(data, arr => arr[1]) || []
    },
    {
      type: 'column',
      name: 'Wybrany okres',
      data: _.map(compareData, arr => arr[1]) || []
    }
  ];

  const chartOptions = _.merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '40%' } },
    fill: { type: ['solid'] },
    labels: _.map(data, arr => arr[0]),
    legend: {
      show: true,
      showForSingleSeries: true,
      showForNullSeries: true
    },
    xaxis: { type: 'datetime' },
    yaxis: [
      {
        title: {
          text: 'Kwota [ zł ]'
        }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: y => {
          if (typeof y !== 'undefined') {
            return `${y} zł`;
          }

          return y;
        }
      },
      x: {
        show: true,
        format: 'dd.MM.yyyy'
      }
    }
  });

  return (
    <Card>
      <CardHeader title="Wykres wpływów" />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <Box display="flex" justifyContent="flex-end">
          <Box sx={{ width: 280 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Porównaj</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={season}
                label="Season"
                onChange={handleCompareSeasonChange}
              >
                { !_.isEmpty(seasons)
                  ? _.map(seasons, obj => (
                    <MenuItem key={obj.id} value={obj.id}>{obj.pl_name}</MenuItem>
                  ))
                  : []}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <ReactApexChart series={CHART_DATA} options={chartOptions} height={364}/>
      </Box>
    </Card>
  );
};
